<template>
    <v-container class="row-padding" grid-list-xl fluid>
        <v-expansion-panels focusable hover inset>
            <!--ACT DETAILS-->
            <v-expansion-panel class="mb-2">
                <v-expansion-panel-header class="pa-0" style="min-height:0" hide-actions>
                    <v-toolbar class="expand-panel-header-custom" dense dark>
                        <v-app-bar-nav-icon></v-app-bar-nav-icon>

                        <v-toolbar-title>Datos del acto</v-toolbar-title>

                        <v-spacer></v-spacer>

                        <v-btn icon>
                            <v-icon>mdi-information</v-icon>
                        </v-btn>
                    </v-toolbar>
                </v-expansion-panel-header>

                <v-expansion-panel-content class="filter-color">

                    <v-card id="info-card" class="item-card mx-auto pa-5" raised elevation="100">

                        <loading-wheel v-if="act_loading"></loading-wheel>
                        <v-card outlined class="filter-row-color my-3">
                            <v-container v-if="!act_loading" class="pa-5" grid-list-xl fluid>
                                <v-row no-gutters>
                                    <v-col cols="auto">
                                        <v-text-field label="Código" color="#da8d2b" style="max-width:90px"
                                            v-model="act['cod']" hide-details="true" type="label" readonly fill>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                        <v-card outlined class="filter-row-color my-3">
                            <v-container v-if="act" class="pa-5" fluid>
                                <v-row no-gutters class="">
                                    <v-col cols="12">
                                        <v-row no-gutters justify="start" align="center">
                                            <v-text-field class="my-3 mr-10" style="max-width:80px" label="Orden"
                                                color="#da8d2b" v-model="act['order']" hide-details="true" type="label"
                                                readonly fill>
                                            </v-text-field>
                                        </v-row>
                                        <v-row no-gutters justify="start" align="center">
                                            <v-text-field class="my-3 mr-10" style="max-width:105px" label="Inicio"
                                                color="#da8d2b" v-model="act['start']" hide-details="true" type="label"
                                                readonly fill>
                                                <template v-slot:append>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-icon dense v-on="on">mdi-ray-start-arrow</v-icon>
                                                        </template>
                                                        "Tiempo de inicio del acto."
                                                    </v-tooltip>
                                                </template>
                                            </v-text-field>
                                            <v-text-field class="my-3 mr-10" style="max-width:95px" label="Finalización"
                                                color="#da8d2b" v-model="act['end']" hide-details="true" type="label"
                                                readonly fill>
                                                <template v-slot:append>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-icon dense v-on="on">mdi-ray-end-arrow</v-icon>
                                                        </template>
                                                        "Tiempo de finalización del acto."
                                                    </v-tooltip>
                                                </template>
                                            </v-text-field>
                                            <v-text-field class="my-3 mr-5" style="max-width:100px" label="Duración"
                                                color="#da8d2b" v-model="act['duration']" hide-details="true"
                                                type="label" readonly fill>
                                                <template v-slot:append>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-icon dense v-on="on">mdi-clock</v-icon>
                                                        </template>
                                                        "Tiempo de duración del acto."
                                                    </v-tooltip>
                                                </template>
                                            </v-text-field>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                        <v-card outlined class="filter-row-color my-3">
                            <v-container v-if="act" class="pa-5" fluid>
                                <v-row no-gutters class="">
                                    <v-col cols="12">
                                        <v-row no-gutters justify="start" align="center" height="300">
                                            <v-textarea label="Contenido" color="#da8d2b"
                                                v-model="act['metadata_contents']" hide-details="true" auto-grow
                                                readonly fill></v-textarea>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-card>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <v-card class="discursive-units-card">
            <v-card-title class="discursive-units-card-title">
                Exploración por unidades discursivas
            </v-card-title>
            <v-expansion-panels focusable hover inset>
                <!--ACTS-->
                <v-expansion-panel v-if="acts.length > 0" class="mb-2">
                    <v-expansion-panel-header class="pa-0" style="min-height:0" hide-actions>
                        <v-toolbar class="expand-panel-header-custom" dense dark>
                            <v-app-bar-nav-icon></v-app-bar-nav-icon>

                            <v-toolbar-title>Actos</v-toolbar-title>

                            <v-spacer></v-spacer>

                            <v-btn icon>
                                <v-icon>mdi-hexagon</v-icon>
                            </v-btn>
                        </v-toolbar>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content class="filter-color pt-4">
                        <v-card class="item-card mx-auto" raised elevation="100">

                            <v-container class="filter-row-color pa-5" fluid>
                                <v-row no-gutters class="">
                                    <v-col cols="12">

                                        <v-data-table class="transparent" show-expand single-expand item-key="cod"
                                            :headers="headers" :items="acts" :expanded.sync="expanded"
                                            @item-expanded="loadActDetails" @update="alert('')" locale="es-ES"
                                            :search="search_acts" :custom-filter="searchFilter" :loading="acts_loading"
                                            loading-text="Cargando datos..."
                                            no-data-text="No se han encontrado resultados" :footer-props="{
                                                itemsPerPageOptions: [10, 20, 30],
                                                'items-per-page-text': 'Actos por página'
                                            }">

                                            <template v-slot:top>
                                                <v-container grid-list-xl fluid>
                                                    <v-layout row wrap>
                                                        <v-flex class="row-padding" xs12>
                                                            <v-row no-gutters justify="end">
                                                                <v-col cols="auto">
                                                                    <v-text-field class="mx-4 my-3"
                                                                        style="max-width:300px" v-model="search_acts"
                                                                        append-icon="search" label="Filtrar" dense>
                                                                    </v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-container>
                                            </template>

                                            <template v-slot:item="{ item, index, expand, isExpanded }">
                                                <tr :id="'row_' + item['cod']" :key="item.cod">
                                                    <td class="text-xs-left">
                                                        <v-btn small text icon @click="expand(!isExpanded)">
                                                            <v-icon color="primary"
                                                                v-if="isExpanded">mdi-chevron-down</v-icon>
                                                            <v-icon color="orange" v-else>mdi-chevron-right</v-icon>
                                                        </v-btn>
                                                    </td>
                                                    <td>
                                                        <v-text-field class="text-center body-1" type="string" dense
                                                            hide-details v-html="item.contents">
                                                        </v-text-field>
                                                    </td>
                                                    <td class="text-center body-1">
                                                        {{ item.duration }}
                                                    </td>
                                                </tr>
                                            </template>

                                            <template v-slot:expanded-item="{ headers, acts }">
                                                <td :colspan="headers.length" style="padding:0">
                                                    <v-card v-if="item" class="filter-color" text tile>
                                                        <v-container v-if="act" class="px-5 py-3" fluid>
                                                            <v-row no-gutters>
                                                                <v-col cols="12">
                                                                    <v-row no-gutters justify="start" align="center">
                                                                        <!--                                                                    <v-text-field
                                                                                                                                            class="my-3 mr-10"
                                                                                                                                            style="max-width:105px"
                                                                                                                                            label="Subactos"
                                                                                                                                            color="#da8d2b"
                                                                                                                                            :value="expanded[0]['subacts_count']"
                                                                                                                                            hide-details="true"
                                                                                                                                            type="label"
                                                                                                                                            readonly
                                                                                                                                            fill
                                                                                                                                            >
                                                                                                                                            <template v-slot:append>
                                                                                                                                                <v-tooltip
                                                                                                                                                    bottom
                                                                                                                                                    >
                                                                                                                                                    <template v-slot:activator="{ on }">
                                                                                                                                                        <v-icon v-on="on">record_voice_over</v-icon>
                                                                                                                                                    </template>
                                    "Número de subactos dentro del acto."
                                    </v-tooltip>
                                    </template>
                                    </v-text-field>
                                    <v-text-field class="my-3 mr-10" style="max-width:80px" label="Palabras"
                                        color="#da8d2b" :value="expanded[0]['tokens_count']" hide-details="true"
                                        type="label" readonly fill>
                                        <template v-slot:append>
                                                                                                                                                <v-tooltip
                                                                                                                                                    bottom
                                                                                                                                                    >
                                                                                                                                                    <template v-slot:activator="{ on }">
                                                                                                                                                        <v-icon v-on="on">font_download</v-icon>
                                                                                                                                                    </template>
                                        "Número de palabras en el acto."
                                        </v-tooltip>
                                        </template>
                                    </v-text-field>-->
                                                                        <loading-wheel
                                                                            v-if="audio_is_loading"></loading-wheel>
                                                                        <div :id="'plyr_act_' + item['cod']">
                                                                            <audio id="audio_player">
                                                                            </audio>
                                                                        </div>
                                                                    </v-row>
                                                                    <v-row no-gutters justify="center" align="center">
                                                                        <v-btn class="ml-10" rounded dense
                                                                            :to="getItemLink('token_details', item['cod'])"
                                                                            dark>
                                                                            <!-- @click.stop="openDetailedView('token_details',
                                                                            item['cod'])" -->
                                                                            <v-icon dark>pageview</v-icon>
                                                                            <span style="text-indent: 5px">Ver
                                                                                Detalles</span>
                                                                        </v-btn>
                                                                    </v-row>
                                                                </v-col>
                                                            </v-row>
                                                        </v-container>
                                                    </v-card>
                                                </td>
                                            </template>

                                            <template v-slot:[`footer.page-text`]="items"> {{ items.pageStart }} - {{
                                                items.pageStop }} de {{ items.itemsLength }} </template>
                                        </v-data-table>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-expansion-panel-content>
                </v-expansion-panel>

                <!--SUBACTOS-->
                <v-expansion-panel class="mb-2">
                    <v-expansion-panel-header class="pa-0" style="min-height:0" hide-actions>
                        <v-toolbar class="expand-panel-header-custom" dense dark>
                            <v-app-bar-nav-icon></v-app-bar-nav-icon>

                            <v-toolbar-title>Subactos</v-toolbar-title>

                            <v-spacer></v-spacer>

                            <v-btn icon>
                                <v-icon>mdi-hexagon-multiple</v-icon>
                            </v-btn>
                        </v-toolbar>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content class="filter-color pt-4">

                        <v-card class="item-card mx-auto" raised elevation="100">

                            <v-container class="filter-row-color pa-5" fluid>
                                <v-row no-gutters class="">
                                    <v-col cols="12">
                                        <v-data-table class="transparent" show-expand single-expand item-key="cod"
                                            :headers="headers" :items="subacts" :expanded.sync="expanded_subact"
                                            @item-expanded="loadSubactDetails" @update="alert('')" locale="es-ES"
                                            :search="search_subacts" :custom-filter="searchFilter"
                                            :loading="subacts_loading" loading-text="Cargando datos..."
                                            no-data-text="No se han encontrado resultados" :footer-props="{
                                                itemsPerPageOptions: [10, 20, 30],
                                                'items-per-page-text': 'Subactos por página'
                                            }">

                                            <template v-slot:top>
                                                <v-container grid-list-xl fluid>
                                                    <v-layout row wrap>
                                                        <v-flex class="row-padding" xs12>
                                                            <v-row no-gutters justify="end">
                                                                <v-col cols="auto">
                                                                    <v-text-field class="mx-4 my-3"
                                                                        style="max-width:300px" v-model="search_subacts"
                                                                        append-icon="search" label="Filtrar" dense>
                                                                    </v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-container>
                                            </template>

                                            <template v-slot:item="{ item, index, expand, isExpanded }">
                                                <tr :id="'row_' + item['cod']" :key="item.cod">
                                                    <td class="text-xs-left">
                                                        <v-btn small text icon @click="expand(!isExpanded)">
                                                            <v-icon color="primary"
                                                                v-if="isExpanded">mdi-chevron-down</v-icon>
                                                            <v-icon color="orange" v-else>mdi-chevron-right</v-icon>
                                                        </v-btn>
                                                    </td>
                                                    <!--                                        <td class="text-left body-1">
                                                                                            {{item["cod"]}}
                                                                                        </td>-->
                                                    <td>
                                                        <v-text-field class="discursive-unit-content text-center"
                                                            type="string" dense hide-details
                                                            v-html="item.metadata_contents">
                                                        </v-text-field>
                                                    </td>
                                                    <td class="text-center body-1">
                                                        {{ item.duration }}
                                                    </td>
                                                </tr>
                                            </template>

                                            <template v-slot:expanded-item="{ headers, item }">
                                                <td :colspan="headers.length" style="padding:0">
                                                    <v-card v-if="item" class="filter-color" text tile>
                                                        <v-container v-if="act" class="px-5 py-3" fluid>
                                                            <v-row no-gutters>
                                                                <v-col cols="12">
                                                                    <v-row no-gutters justify="start" align="center">
                                                                        <!--                                                                    <v-text-field
                                                                                                                                            class="my-3 mr-10"
                                                                                                                                            style="max-width:105px"
                                                                                                                                            label="Subactos"
                                                                                                                                            color="#da8d2b"
                                                                                                                                            v-model="expanded_subact[0]['subacts_count']"
                                                                                                                                            hide-details="true"
                                                                                                                                            type="label"
                                                                                                                                            readonly
                                                                                                                                            fill
                                                                                                                                            >
                                                                                                                                            <template v-slot:append>
                                                                                                                                                <v-tooltip
                                                                                                                                                    bottom
                                                                                                                                                    >
                                                                                                                                                    <template v-slot:activator="{ on }">
                                                                                                                                                        <v-icon v-on="on">record_voice_over</v-icon>
                                                                                                                                                    </template>
                            "Número de intervenciones dentro del diálogo."
                            </v-tooltip>
                            </template>
                            </v-text-field>
                            <v-text-field class="my-3 mr-10" style="max-width:80px" label="Palabras" color="#da8d2b"
                                v-model="expanded_subact[0]['tokens_count']" hide-details="true" type="label" readonly
                                fill>
                                <template v-slot:append>
                                                                                                                                                <v-tooltip
                                                                                                                                                    bottom
                                                                                                                                                    >
                                                                                                                                                    <template v-slot:activator="{ on }">
                                                                                                                                                        <v-icon v-on="on">font_download</v-icon>
                                                                                                                                                    </template>
                                "Número de palabras en el diálogo."
                                </v-tooltip>
                                </template>
                            </v-text-field>-->
                                                                        <loading-wheel
                                                                            v-if="audio_is_loading"></loading-wheel>
                                                                        <div :id="'plyr_subact_' + item['cod']">
                                                                            <audio id="audio_player">
                                                                            </audio>
                                                                        </div>
                                                                    </v-row>
                                                                    <v-row no-gutters justify="center" align="center">
                                                                        <v-btn class="ml-10" rounded dense
                                                                            :to="getItemLink('subact_details', item['cod'])"
                                                                            dark>
                                                                            <!-- @click.stop="openDetailedView('subact_details', item['cod'])" -->
                                                                            <v-icon dark>pageview</v-icon>
                                                                            <span style="text-indent: 5px">Ver
                                                                                Detalles</span>
                                                                        </v-btn>
                                                                    </v-row>
                                                                </v-col>
                                                            </v-row>
                                                        </v-container>
                                                    </v-card>
                                                </td>
                                            </template>

                                            <template v-slot:[`footer.page-text`]="items"> {{ items.pageStart }} - {{
                                                items.pageStop }} de {{ items.itemsLength }} </template>
                                        </v-data-table>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-card>
    </v-container>
</template>
<script>
import api from '@/restApi';
import { Breadcrumb, Loading } from '@/components';

export default {
    name: 'act-details',
    bodyClass: 'default-page',
    props: {
        code: {
            type: String,
            default() {
                return "";
            }
        }
    },
    data() {
        return {
            page: null,
            section: null,
            subsection: null,
            search_acts: "",
            search_subacts: "",
            player: null,
            act: null,
            acts: [],
            subacts: [],
            alternate: false,
            audio_is_loading: true,
            expanded: [],
            expanded_subact: [],
            act_loading: true,
            acts_loading: true,
            subacts_loading: true,
            headers: [
                {
                    text: "Contenido",
                    align: "center",
                    value: "metadata_contents"
                },
                {
                    text: "Duración",
                    align: "center",
                    value: "duration",
                    width: 100
                }
            ]
        };
    },
    created: function () {
        const params = this.$route.params;

        this.page = params.page;
        this.section = params.section;
        this.subsection = params.subsection;

        this.loadActData();
    },
    mounted: function () {
    },
    watch: {
    },
    methods: {
        getItemLink(view, cod) {
            const link = '/pages/' + this.page + "/" + this.section + "/" + this.subsection + "/" + view + "/" + cod;

            return link;
        },
        searchFilter(value, search, item) {
            //                console.log(value + " - " + search + " - " + item);

            return (value !== null &&
                search !== null && typeof value === 'string' &&
                this.$mout.string.contains(item.metadata_contents, search));
        },
        async loadActDetails({ item }) {
            var elementId, conversationCode;
            var start, duration;
            var isExpanding;
            var self = this;

            self.audio_is_loading = true;

            self.alternate = !self.alternate;

            //                console.log(self.expanded)
            isExpanding = !this.$mout.array.filter(self.expanded, function (item2) {
                //                console.log(item2["cod"],"-",item["cod"])
                return item2["cod"] === item["cod"];
            }).length > 0;
            //                console.log("EOOOOOOOOOOOOOOOOOOOOO",isExpanding)

            if (this.$mout.lang.isEmpty(item) || !isExpanding) {
                return;
            }

            //                console.log("Element", "plyr_act_" + item["cod"]);
            //                console.log("Expanded item", item);

            elementId = "#audio_player";
            conversationCode = self.act["cod"].substring(0, self.act["cod"].indexOf("-"));
            start = item["start"];
            duration = item["end"] - item["start"];

            if (self.player) {
                self.player.destroy();
            }

            setTimeout(async function () {
                self.player = await self.loadPlayer(elementId, conversationCode, start, duration, self.audio_is_loading);

                self.audio_is_loading = false;
            }, 10);
        },
        async loadSubactDetails({ item }) {
            var elementId, conversationCode;
            var start, duration;
            var isExpanding;
            var self = this;

            self.audio_is_loading = true;

            self.alternate = !self.alternate;

            //                console.log(self.expanded_subact)
            isExpanding = !this.$mout.array.filter(self.expanded_subact, function (item2) {
                //                console.log(item2["cod"],"-",item["cod"])
                return item2["cod"] === item["cod"];
            }).length > 0;

            if (this.$mout.lang.isEmpty(item) || !isExpanding) {
                return;
            }

            //                console.log("Element", "plyr_subact_" + item["cod"]);
            //                console.log("Expanded item", item);

            elementId = "#audio_player";
            conversationCode = item["cod"].substring(0, item["cod"].indexOf("-"));
            start = item["start"];
            duration = item["end"] - item["start"];

            if (self.player) {
                self.player.destroy();
            }

            setTimeout(async function () {
                self.player = await self.loadPlayer(elementId, conversationCode, start, duration, self.audio_is_loading);

                self.audio_is_loading = false;
            }, 10);
        },
        openDetailedView(view, inputParams, modifiers) {
            this.$emit('clicked', view + (inputParams ? "/" + inputParams : "") + "/" + (modifiers ? "/" + inputParams : ""));
        },
        async loadActData() {
            await this.loadAct();
            this.loadActs();
            this.loadSubacts();
        },
        async loadAct() {
            this.act_loading = true;

            const queryString = "cod=" + this.code;

            // Get the act with given code
            const response = await api.get("act", queryString);

            if (response instanceof Error) {
                // Do not continue
                return;
            }

            const acts = response;

            if (acts.length <= 0) {
                return;
            }


            this.act = acts[0];

            //                this.act["tokens_count"] = await api.getTokenCount(this.act["cod"]);
            //                this.act["acts_count"] = await api.getInterventionCount(this.act["cod"]);

            this.act["duration"] = this.millisToMinutesAndSeconds(this.act["end"] - this.act["start"]);
            this.act["start"] = this.millisToMinutesAndSeconds(this.act["start"]);
            this.act["end"] = this.millisToMinutesAndSeconds(this.act["end"]);

            this.act_loading = false;
        },
        async loadActs() {
            this.acts_loading = true;

            const queryString = "act=" + this.act["_id"] + "&fields=cod,metadata_contents,start,end&sort={\"field\":\"order\",\"dir\":\"asc\"}";

            // Get the act acts
            const response = await api.getAllItems("act", queryString);

            if (response instanceof Error) {
                // Do not continue
                return;
            }

            const acts = response;

            for (var act of acts) {
                act["duration"] = this.millisToMinutesAndSeconds(act["end"] - act["start"]);
            }

            this.acts = acts;

            this.act_loading = false;
        },
        async loadSubacts() {
            this.subacts_loading = true;

            const queryString = "act=" + this.act["_id"] + "&fields=cod,metadata_contents,start,end&sort={\"field\":\"order\",\"dir\":\"asc\"}";

            // Get the act subacts
            const response = await api.getAllItems("subact", queryString);

            if (response instanceof Error) {
                // Do not continue
                return;
            }

            const subacts = response;

            for (var subact of subacts) {
                subact["duration"] = this.millisToMinutesAndSeconds(subact["end"] - subact["start"]);
            }

            this.subacts = subacts;

            this.subacts_loading = false;
        }
    },
    components: {
        [Breadcrumb.name]: Breadcrumb,
        [Loading.name]: Loading
    }
};
</script>

<style>
.transparent>.table,
.transparent>.table__overflow>.table,
.transparent>.table>.datatable__actions {
    background-color: #fde19a;
}
</style>
